import clsx from 'clsx'
import React, { FC } from 'react'
import { Link } from 'react-router-dom'
import { useLayout } from '../../../core/LayoutProvider'
import { usePageData } from '../../../core/PageData'

const DefaultTitle: FC = () => {
  const { pageTitle, pageDescription, pageBreadcrumbs } = usePageData()
  const { config, classes } = useLayout()

  return (
    <>
      <style>{`
        .dt-title {
          font-size: 18px;
          font-weight: 700;
          letter-spacing: -.01em;
          color: var(--bs-gray-900, #181c32);
          margin: 0;
          line-height: 1.3;
        }
        html[data-theme-mode='dark'] .dt-title {
          color: #f5f5f5;
        }

        .dt-desc {
          font-size: 12px;
          font-weight: 500;
          color: var(--bs-gray-500, #a1a5b7);
          margin-left: 10px;
          padding-left: 10px;
          border-left: 1px solid var(--bs-gray-300, #e4e6ef);
        }
        html[data-theme-mode='dark'] .dt-desc {
          color: #6d6d80;
          border-color: #2d2d43;
        }

        /* Breadcrumb */
        .dt-breadcrumb {
          display: flex; align-items: center;
          list-style: none; margin: 0; padding: 0;
          gap: 0;
        }
        .dt-breadcrumb li {
          display: flex; align-items: center;
          font-size: 12px; font-weight: 500;
        }
        .dt-breadcrumb .bc-link {
          color: var(--bs-gray-500, #a1a5b7);
          text-decoration: none;
          transition: color .15s;
        }
        .dt-breadcrumb .bc-link:hover {
          color: var(--theme-primary, #009ef7);
        }
        html[data-theme-mode='dark'] .dt-breadcrumb .bc-link {
          color: #565674;
        }
        html[data-theme-mode='dark'] .dt-breadcrumb .bc-link:hover {
          color: var(--theme-primary, #009ef7);
        }
        .dt-breadcrumb .bc-sep {
          width: 4px; height: 4px; border-radius: 50%;
          background: var(--bs-gray-300, #e4e6ef);
          margin: 0 6px;
        }
        html[data-theme-mode='dark'] .dt-breadcrumb .bc-sep {
          background: #363650;
        }
        .dt-breadcrumb .bc-current {
          color: var(--bs-gray-700, #5e6278);
          font-weight: 600;
        }
        html[data-theme-mode='dark'] .dt-breadcrumb .bc-current {
          color: #cdcdde;
        }
      `}</style>

      <div
        id='kt_page_title'
        data-kt-swapper='false'
        data-kt-swapper-mode='prepend'
        data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
        className={clsx('page-title d-flex flex-column justify-content-center', classes.pageTitle.join(' '))}
      >
        {/* Başlık + açıklama */}
        {pageTitle && (
          <div className='d-flex align-items-center'>
            <h1 className='dt-title'>{pageTitle}</h1>
            {pageDescription && config.pageTitle?.description && (
              <span className='dt-desc'>{pageDescription}</span>
            )}
          </div>
        )}

        {/* Breadcrumb */}
        {pageBreadcrumbs &&
          pageBreadcrumbs.length > 0 &&
          config.pageTitle?.breadCrumbs && (
            <ul className='dt-breadcrumb mt-1'>
              {Array.from(pageBreadcrumbs).map((item, index) => (
                <li key={`${item.path}${index}`}>
                  {!item.isSeparator ? (
                    <Link
                      className={clsx('bc-link', { 'bc-current': item.isActive })}
                      to={item.path}
                    >
                      {item.title}
                    </Link>
                  ) : (
                    <span className='bc-sep' />
                  )}
                </li>
              ))}
              <li>
                <span className='bc-sep' />
                <span className='bc-current'>{pageTitle}</span>
              </li>
            </ul>
          )}
      </div>
    </>
  )
}

export { DefaultTitle }